'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Button = function Button(_ref) {
  var onPress = _ref.onPress,
      title = _ref.title;

  if (typeof navigator !== 'undefined' && navigator.product === "ReactNative") {
    try {
      var MyButton = require('react-native').Button;

      return _react2["default"].createElement(MyButton, {
        title: title,
        onPress: onPress
      });
    } catch (e) {}
  } else {
    return _react2["default"].createElement('button', {
      onClick: onPress
    }, title);
  }
};

exports["default"] = Button;